import api from './api';
import { API_ENDPOINTS } from '../constants/config';

class LogService {
  async getAppLogs(lines = 1000) {
    try {
      const response = await api.get(`${API_ENDPOINTS.LOGS}/?lines=${lines}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching logs:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }
}

export default new LogService();
